import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './menu-item-text.module.css';

type Props = {
    primary: string;
    secondary?: string;
    className?: string;
};

export const MenuItemText = ({primary, secondary, className}: Props) => {
    const [textPrimaryCls, textSecondaryCls] = useTypography([
        {
            size: TypographySize.BodyL,
        },
        {
            size: TypographySize.BodyS,
        },
    ]);

    return (
        <div
            className={classNames(styles.text, className, {
                [styles.oneLine]: !secondary,
            })}
        >
            <span className={classNames(textPrimaryCls, styles.primary)}>{primary}</span>
            <span className={classNames(textSecondaryCls, styles.secondary)}>{secondary}</span>
        </div>
    );
};
